import React from "react";
import { LoadingSpinner } from "./LoadingSpinner";

export interface AsyncButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  loadingText?: string;
}

export const AsyncButton = React.forwardRef<
  HTMLButtonElement,
  AsyncButtonProps
>(
  (
    {
      loading = false,
      loadingText,
      disabled,
      children,
      className = "btn btn-primary",
      ...rest
    },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        type={rest.type ?? "button"}
        className={`${className} d-flex flex-wrap align-items-center justify-content-center gap-2`}
        disabled={disabled || loading}
        aria-busy={loading}
        {...rest}
      >
        {loading && <LoadingSpinner size="small" />}
        {loading ? loadingText || children : children}
      </button>
    );
  },
);
